import { render, staticRenderFns } from "./PercentageFlat.vue?vue&type=template&id=5e3fd8cb&"
import script from "./PercentageFlat.vue?vue&type=script&lang=js&"
export * from "./PercentageFlat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports